module.exports = __webpack_public_path__ + "static/img/contact_logo8.89a005f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo8.png
// module id = 67Jg
// module chunks = 1